import React from "react";
import { Routes, Route } from "react-router-dom";

import DynamicPanel  from "./components/dynamic_panel";
import HomePage      from "./components/HomePage";
import SchedulesPage from "./components/SchedulesPage";
import CurtainsPage  from "./components/CurtainsPage";
import Login         from "./components/Login.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import Layout        from "./components/Layout.jsx";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={
        <ProtectedRoute><Layout><HomePage /></Layout></ProtectedRoute>
      } />

      <Route path="/dynamic" element={
        <ProtectedRoute><Layout><DynamicPanel /></Layout></ProtectedRoute>
      } />

      <Route path="/schedules" element={
        <ProtectedRoute><Layout><SchedulesPage /></Layout></ProtectedRoute>
      } />

      <Route path="/curtains" element={
        <ProtectedRoute><Layout><CurtainsPage /></Layout></ProtectedRoute>
      } />
    </Routes>
  );
};

export default AppRoutes;
